(function () {
	'use strict';

	/**
	 * @ngdoc controller
	 * @name mx.shell.Controller
	 * @module mx.shell
	 *
	 * @description
	 * The controller to associate with a Item-Chooser located on the toolbar
	 * @requires {@ref mx.shell.AppsService mx.shell.AppsService}
	 */

	angular.module('mx.shell').controller('mx.shell.ToolbarAppSwitcherController', [
		'$scope',
		'mx.shell.AppsService',
		function mxToolbarAppSwitcherController($scope, appsService) {
			// eslint-disable-next-line angular/controller-as
			$scope.items = _.map(appsService.getApplications(), function (app) {
				return {
					$at_id: app.name,
					$at_type: 'application_switcher',
					name: app.title,
					icon: app.icon,
					execute: app.onItemClick,
					isFocused: app.isChecked,
				};
			});
		},
	]);
})();
